<template>
	<div class="settings">
		<b-container class="bv-example-row">
			<b-card header-tag="header" footer-tag="footer">
				<div slot="header" class="top-card d-flex align-items-center justify-content-between">
					<span>
						<h5>{{ $t('sidebar.pos.cashboxCategoryItem') }} - {{ categoryName }}</h5>
					</span>
					<b-button variant="outline-info" @click.prevent="openCashboxCategoryItemModal({})">
						<i class="fa fa-plus" /> &nbsp;
						<span>{{ $t('client.addClient') }}</span>
					</b-button>
				</div>

				<b-table class="generalTableClass" hover="hover" striped="striped" bordered="bordered" small="small"
					fixed="fixed" :items="cashboxCategoryItemList" :fields="computedFields" show-empty>
					<template slot="empty">
						<h4>{{ $t('empty') }}</h4>
					</template>

					<template slot="id" slot-scope="data">
						<strong>{{ data.index + 1 }}</strong>
					</template>

					<template slot="name" slot-scope="data">
						{{
							data.item.itemDto.barcode
						}} <b>/</b> {{ data.item.itemDto.name ? data.item.itemDto.name : data.item.itemDto.itemName
						}} <b>/</b> {{
							data.item.itemDto.artikul
						}}
					</template>

					<template slot="actions" slot-scope="data">
						<!-- <b-link @click.prevent="openCashboxCategoryItemModal(data)">
							<i class="fa fa-pencil editBtn" />
						</b-link> -->
						<b-link :key="data.item.id + 'delete'" @click="onOpen(data.item.id)"
							:id="'popOverDelete' + data.item.id">
							<i class="fa fa-trash editBtn" />
						</b-link>
						<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
						<b-popover :key="data.item.id + 'popover'" :target="'popOverDelete' + data.item.id"
							placement="auto" container="myContainer" :ref="'popover' + data.item.id"
							class="refDeleteConfirm">
							<template slot="title">
								<b-button @click="onClose(data.item.id)" class="close" aria-label="Close"
									style="margin-left: 5px">
									<span class="d-inline-block" aria-hidden="true">&times;</span>
								</b-button>
								{{ $t('actions.deletetitle') }}
							</template>

							<div>
								<div class="row mt-1">
									<div class="col-6">
										<b-button variant="outline-danger" size="sm" block
											@click="onClose(data.item.id)">{{
												$t('actions.no') }}
										</b-button>
									</div>
									<div class="col-6">
										<b-button variant="outline-success" size="sm" block
											@click="deleteCashboxCategoryItem(data.item.id)">{{
												$t('actions.yes') }}
										</b-button>
									</div>
								</div>
							</div>
						</b-popover>
					</template>
				</b-table>

				<!--		MODAL FOR ADDING/EDITING CASHBOX		-->
				<b-modal body-class="refModal subReferenceModal" ref="updateRefModal" hide-footer ok-title="Save"
					:title="modalForAdding ? $t('reference.create.title') : $t('reference.update-title')" size="lg">
					<div>
						<p v-if="refInputNotFilled" style="color: red;">{{ $t('please-title') }}</p>

						<b-form-group label-cols="4" label-cols-lg="3" label-size="sm"
							:label="$t('reference.create.name')" label-for="refName" class="required">
							<multiselect label="name" track-by="itemId" v-model="editingItem.item" :options="whItems"
								:searchable="true" :show-labels="false" :close-on-select="true" :internal-search="false"
								@search-change="loadItems($event)" :placeholder="$t('incomes.create.product')">
								<template slot="singleLabel" slot-scope="props">
									<span>
										{{
											props.option.barcode
										}} <b>/</b> {{
											props.option.name ? props.option.name : props.option.itemName
										}} <b>/</b> {{ props.option.artikul }}
									</span>
								</template>
								<template slot="option" slot-scope="option">
									<span>
										{{
											option.option.barcode
										}} <b>/</b> {{ option.option.name ? option.option.name : option.option.itemName
										}} <b>/</b> {{
											option.option.artikul
										}}
									</span>
								</template>
							</multiselect>
						</b-form-group>

						<div class="row mt-3 createRoleModalButtons justify-content-end">
							<div class="col-4">
								<b-button variant="outline-danger" size="sm" block
									@click="closeCashboxCategoryItemModal">
									{{ $t('actions.cancel') }}
								</b-button>
							</div>
							<div class="col-4">
								<b-button variant="outline-success" size="sm" block @click="addNewCashboxCategoryItem">
									{{ $t('actions.save') }}
								</b-button>
							</div>
						</div>
					</div>
				</b-modal>
			</b-card>
		</b-container>
	</div>
</template>

<script>
import { TokenService } from "@/services/storage.service";
import PosService from "@/services/pos.service";
import ApiService from "@/services/api.service";
import Multiselect from 'vue-multiselect'

const itemInitial = {
	item: null,
	status: null,
	categoryId: null,
};
export default {
	components: {
		Multiselect
	},
	data() {
		return {
			whItems: [],
			show: false,
			errorShow: false,
			modalForAdding: false,
			cashboxCategoryList: [],
			refInputNotFilled: false,
			cashboxCategoryItemList: [],
			editingItem: Object.assign({}, itemInitial),

			fields: [
				{
					key: "id",
					label: "#",
					class: "role_id",
				},
				{
					key: "name",
					label: this.$t("reference.name"),
				},
				{
					key: "actions",
					label: this.$t("employees.actions"),
					class: "table_actions",
					sortable: true
				},
			],
		}
	},
	async created() {
		await this.fetchCashboxCategoryList()
		await this.fetchCashboxCategoryItemList()
	},
	computed: {
		computedFields() {
			return this.fields
		},
		depCurrencyName() {
			return TokenService.getDepCurrencyName();
		},
		categoryName() {
			const category = this.cashboxCategoryList.find(
				item => item.id === Number(this.$route.params.id)
			)
			return category ? category.name : ''
		}
	},
	methods: {
		onOpen(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('open')
		},
		onClose(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('close')
		},
		async deleteCashboxCategoryItem(itemId) {
			ApiService.delete(`cashbox-category-item/delete/${itemId}`)
				.then(res => {
					this.fetchCashboxCategoryItemList()
				})
		},
		/* POPOVER METHODS END */
		closeCashboxCategoryItemModal() {
			this.refInputNotFilled = false;
			this.$refs.updateRefModal.hide();
		},
		openCashboxCategoryItemModal(data) {
			this.refInputNotFilled = false;
			if (data.item) {
				this.modalForAdding = false;
				this.editingItem.id = data.item.id;
				this.editingItem.name = data.item.name;
				this.$refs.updateRefModal.show();
			} else {
				this.editingItem = Object.assign({}, itemInitial);
				this.modalForAdding = true;
				this.$refs.updateRefModal.show();
			}
		},
		loadItems(event) {
			if (!this.skyShopSale) {
				if (event.length > 3) {
					this.loading = true
					ApiService.post(`/item/search/categories?page=${0}&limit=${10}`, { name: event, categoryId: 14 }).then(async res => {
						this.whItems = res.data.items
						this.loading = false
					}).catch(er => {
						this.loading = false
						this.$vs.notify({
							title: er.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				}
			} else {
				if (event !== '') {
					this.whItems = this.viewSkyDocItems.filter((item) => {
						if (item.barcode.toLowerCase().indexOf(event.toLowerCase()) >= 0)
							return item.barcode.toLowerCase().indexOf(event.toLowerCase()) >= 0
						else if (item.itemName.toLowerCase().indexOf(event.toLowerCase()) >= 0)
							return item.itemName.toLowerCase().indexOf(event.toLowerCase()) >= 0
					});
				} else {
					this.whItems = this.viewSkyDocItems
				}
			}
		},
		fetchCashboxCategoryList(fetchAndUpdate = false) {
			ApiService.get(`cashbox-category/list-search?search`)
				.then(res => {
					this.cashboxCategoryList = res.data
					// this.closeCashboxCategoryModal()
				})
		},
		fetchCashboxCategoryItemList(fetchAndUpdate = false) {
			ApiService.get(`cashbox-category-item/list?categoryId=${this.$route.params.id}`)
				.then(res => {
					this.cashboxCategoryItemList = res.data
					this.closeCashboxCategoryItemModal()
				})
		},
		addNewCashboxCategoryItem() {
			if (this.editingItem.item.id) {
				this.refInputNotFilled = false
				if (this.modalForAdding)
					ApiService.post(`cashbox-category-item/create`, { itemId: this.editingItem.item.id, categoryId: Number(this.$route.params.id) })
						.then(res => {
							this.fetchCashboxCategoryItemList()
						})
				else
					ApiService.put(`cashbox-category-item/update/${this.editingItem.id}`, this.editingItem)
						.then(res => {
							this.fetchCashboxCategoryItemList(true)
						})
			} else {
				this.refInputNotFilled = true
			}
		},
	}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.btn-frame {
	display: flex;
	justify-content: flex-end;
	margin-top: 10px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	/* display: none; <- Crashes Chrome on hover */
	-webkit-appearance: none;
	margin: 0;
	/* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
	-moz-appearance: textfield;
	/* Firefox */
}

.editBtn {
	font-size: 14px;
	cursor: pointer;
}

.cashbox {
	display: flex;
	justify-content: center;
}

.cashboxnumber {
	font-size: 20px;
	margin-bottom: 4px;
	margin-left: 10px;
}

.success-save {
	display: flex;
	justify-content: center;
	padding: 8px;
}
</style>
